import React, { useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { sortCaret, headerSortingClasses } from "../../../_metronic/_helpers";
import { useSelector, useDispatch } from "react-redux";
import { selectBackCustomer, createBackCustomer } from "./rejectSlice";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
} from "../../utility";
function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}

export const RejectBackCustomer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const forceUpdate = useForceUpdate();

  const data = useSelector(selectBackCustomer);

  // Add status field to prevent object is not extensible error
  const initData = data.map((item, index) => ({
    ...item,
    no: index + 1,
    status: null,
  }));

  const [tableData, setTableData] = useState(initData);
  console.log(tableData, "tabeldata");

  // Return if data null
  if (!tableData.length > 0) {
    history.push("/reject-return");
  }

  const handleSave = () => {
    const arrayId = tableData.map((e) => e.returnDetailId);
    console.log(arrayId, "TEST");

    const params = {
      data: arrayId,
    };
    console.log(params, "params");
    callApi(params);
  };

  const callApi = async (params) => {
    try {
      const response = await dispatch(createBackCustomer(params));
      if (response.payload.status === 200) {
        console.log(response, "respon");
        const action = await showSuccessDialog(
          "Data has been back to customer!"
        );
        if (action.isConfirmed) history.push("/reject-return");
      }
    } catch (error) {
      console.log("error", error);
      showErrorDialog("Something went wrong!");
    }
  };
  const dateFormatter = (cell) => {
    return <span>{formatDate(cell)}</span>;
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Invoice Ref Num",
      dataField: "invoiceNo",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "APL Return Number ",
      dataField: "retNumber",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reason",
      dataField: "reasonName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "APL Sales Office",
      dataField: "plantname",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Cust Name",
      dataField: "customerName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Doc Date",
      dataField: "docDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Qty",
      dataField: "qty",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    // {
    //   text: "RejectQty",
    //   dataField: "actual_qty",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    //   formatter: inputQtyFormmater,
    //   formatExtraData: tableData,
    // },
    {
      text: "Uom",
      dataField: "uom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Remark Reject by CW",
      dataField: "rejectRemarks",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Rejected By",
      dataField: "userName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
    {
      text: "Reject Date",
      dataField: "reject_Date",
      formatter: dateFormatter,
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
    },
  ];

  const options = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };

  return tableData.length > 0 ? (
    <Card>
      <CardHeader title="Reject Back To Customer"></CardHeader>
      <CardBody>
        {/* Table */}
        <BootstrapTable
          wrapperClasses="table-responsive"
          classes="table table-head-custom table-vertical-center overflow-hidden"
          bootstrap4
          bordered={false}
          keyField="returnDetailId"
          data={tableData}
          columns={columns}
          pagination={paginationFactory(options)}
          hover
        />

        {/* Footer */}
        <Form className="mt-14">
          <Row>
            <Col md="6" sm="6" lg="8">
              <Button variant="success" className="mr-5" onClick={handleSave}>
                Save
              </Button>
              <Button
                variant="secondary"
                className="mr-5"
                onClick={() => history.push("/reject-return")}
              >
                Back
              </Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  ) : null;
};
